import { render, staticRenderFns } from "./BadgesPage.vue?vue&type=template&id=7065cb31&scoped=true"
import script from "./BadgesPage.vue?vue&type=script&lang=js"
export * from "./BadgesPage.vue?vue&type=script&lang=js"
import style0 from "./BadgesPage.vue?vue&type=style&index=0&id=7065cb31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7065cb31",
  null
  
)

export default component.exports